const DAY_NAMES = ['월', '화', '수', '목', '금', '토', '일'];

function SchedulerStep({
  selectedDays, imageGenDays, setImageGenDays,
  uploadTime, setUploadTime, postsPerDay, setPostsPerDay,
  toggleDay,
}) {
  return (
    <section style={{ marginBottom: '32px' }}>
      <h3 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6 flex items-center gap-3">
        <span style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '32px', height: '32px', borderRadius: '50%',
          background: '#1313ec', color: 'white', fontSize: '14px'
        }}>3</span>
        스케줄러 설정
      </h3>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '32px', background: '#111118', padding: '32px',
        borderRadius: '12px', border: '1px solid #3b3b54'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px' }}>
            요일 선택
          </span>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {DAY_NAMES.map((day, index) => (
              <button
                key={day}
                onClick={() => toggleDay(index)}
                style={{
                  width: '40px', height: '40px', borderRadius: '50%',
                  background: selectedDays[index] ? '#1313ec' : '#282839',
                  color: selectedDays[index] ? 'white' : '#9d9db9',
                  border: 'none', fontWeight: '700', fontSize: '12px',
                  cursor: 'pointer', transition: 'all 0.3s'
                }}
              >
                {day}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px' }}>
            시간 선택 (일일 포스팅 시간)
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="time"
              value={uploadTime}
              onChange={(e) => setUploadTime(e.target.value)}
              style={{
                height: '48px', padding: '0 16px', background: '#1c1c27',
                border: '1px solid #3b3b54', borderRadius: '12px', outline: 'none'
              }}
            />
            <select
              value={postsPerDay}
              onChange={(e) => setPostsPerDay(e.target.value)}
              style={{
                height: '48px', padding: '0 16px', background: '#1c1c27',
                border: '1px solid #3b3b54', borderRadius: '12px',
                outline: 'none', minWidth: '140px'
              }}
            >
              <option value="1">일 1회 포스팅</option>
              <option value="2">일 2회 포스팅</option>
              <option value="3">일 3회 포스팅</option>
            </select>
          </div>
        </div>

        {/* 요일별 이미지 생성 토글 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', paddingLeft: '4px' }}>
              AI 이미지 생성 (요일별)
            </span>
            <span style={{ fontSize: '12px', color: '#9d9db9', paddingLeft: '4px' }}>
              선택한 요일에만 AI 이미지를 생성합니다. 미선택 요일은 캡션만 생성됩니다.
            </span>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {DAY_NAMES.map((day, index) => {
              const isUploadDay = selectedDays[index];
              const isImageDay = imageGenDays[index];
              return (
                <button
                  key={`img-${day}`}
                  onClick={() => {
                    if (!isUploadDay) return;
                    const newDays = [...imageGenDays];
                    newDays[index] = !newDays[index];
                    setImageGenDays(newDays);
                  }}
                  style={{
                    width: '40px', height: '40px', borderRadius: '50%',
                    background: !isUploadDay ? '#1a1a2e' : isImageDay ? '#10b981' : '#282839',
                    color: !isUploadDay ? '#4a4a5a' : isImageDay ? 'white' : '#9d9db9',
                    border: !isUploadDay ? '1px dashed #3b3b54' : 'none',
                    fontWeight: '700', fontSize: '12px',
                    cursor: isUploadDay ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s', opacity: isUploadDay ? 1 : 0.5,
                  }}
                  title={!isUploadDay ? '업로드 요일이 아닙니다' : isImageDay ? '이미지 생성 ON' : '이미지 생성 OFF'}
                >
                  {day}
                </button>
              );
            })}
          </div>
          <div style={{ display: 'flex', gap: '12px', fontSize: '11px', color: '#9d9db9', paddingLeft: '4px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />
              이미지 생성
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#282839', display: 'inline-block' }} />
              캡션만
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#1a1a2e', border: '1px dashed #3b3b54', display: 'inline-block' }} />
              업로드 안함
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SchedulerStep;
